import { cn } from '@restworld/utils-common';

export type ModalSubTitleProps = {
  children: React.ReactNode | string;
};

// Login page body text under the title: 14px, neutral-700, centred, same size at every breakpoint.
export const authPageSubtitleClassName = 'w-full text-sm text-neutral-700 text-center';

export const AuthSubtitle = ({
  isModal = true,
  className,
  ...props
}: { isModal?: boolean } & React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-base font-normal text-gray-600 text-center', !isModal && 'text-left', className)} {...props} />
);
